module.exports = __webpack_public_path__ + "static/media/incident.3f4e5cdf.png";